import {
  CATEGORY_REQUEST,
  CATEGORY_SUCCESS,
  CREATE_CATEGORY_REQUEST,
  UPDATE_SKU_REQUEST,
  DEFAULT_SUCCESS,
  DELETE_SKU_REQUEST,
  DELETE_CATEGORY_REQUEST,
  UPDATE_CATEGORY_REQUEST,
  SKU_LIST_REQUEST,
  SKU_LIST_SUCCESS,
  REQUEST_FAILURE,
  CLEAR_MESSAGE
} from './constants';

let initialState = {
  message: '',
  messageType: '',
  categoryList: [],
  skuList: [],
  loading: false
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case CATEGORY_REQUEST:
      return { ...state, loading: true };
    case DELETE_SKU_REQUEST:
      return { ...state, loading: true };
    case DELETE_CATEGORY_REQUEST:
      return { ...state, loading: true };
    case UPDATE_CATEGORY_REQUEST:
      return { ...state, loading: true };
    case SKU_LIST_REQUEST:
      return { ...state, loading: true };
    case SKU_LIST_SUCCESS:
      return {
        ...state,
        skuList: action.skuList,
        message: '',
        messageType: '',
        loading: false
      };
    case CATEGORY_SUCCESS:
      return {
        ...state,
        categoryList: action.categoryList,
        loading: false
      };
    case UPDATE_SKU_REQUEST:
      return { ...state, loading: true };
    case CREATE_CATEGORY_REQUEST:
      return { ...state, loading: true };
    case DEFAULT_SUCCESS:
      return {
        ...state,
        message: action.message || '',
        messageType: action.messageType || '',
        loading: false
      };
    case REQUEST_FAILURE:
      return { ...state, message: action.error, messageType: 'error', loading: false };
    case CLEAR_MESSAGE:
      return { ...state, message: '', messageType: '', loading: false };
    default:
      return state;
  }
}

export default reducer;
